import PropTypes from 'prop-types';
import React from 'react';
import { Tag, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { CheckOutlined, WarningOutlined, SyncOutlined } from '@ant-design/icons';

const getEpisodeAudioStatusConfig = (status) => {
  const configs = [
    {
      condition: status === 'failed' || status === 'error',
      icon: <WarningOutlined />,
      className: 'status-tag--error',
      message: <FormattedMessage defaultMessage="Encoding failed" />,
      tooltip: (
        <FormattedMessage defaultMessage="An error occurred while encoding your audio file. Try re-uploading the audio file." />
      ),
    },
    {
      condition: status === 'done',
      icon: <CheckOutlined />,
      className: 'status-tag--success',
      message: <FormattedMessage defaultMessage="Encoded" />,
      tooltip: null,
    },
    {
      condition: status === 'queued' || status === 'processing',
      icon: <SyncOutlined spin />,
      className: 'status-tag--default',
      message: <FormattedMessage defaultMessage="Encoding" />,
      tooltip: null,
    },
  ];
  return configs.find((item) => item.condition);
};

const EpisodeAudioStatusTag = ({ status }) => {
  const match = getEpisodeAudioStatusConfig(status);

  if (!match) {
    return null;
  }

  const { icon, className, message, tooltip } = match;

  return (
    <Tooltip title={tooltip}>
      <Tag className={`status-tag ${className}`}>
        <div>
          {icon}
          {message}
        </div>
      </Tag>
    </Tooltip>
  );
};

EpisodeAudioStatusTag.propTypes = {
  status: PropTypes.oneOf(['failed', 'error', 'done', 'queued', 'processing']),
  isLoading: PropTypes.bool,
};

export default EpisodeAudioStatusTag;
